const Input = {
  variants: {
    clean: {
      field: {
        bg: 'white',
        borderRadius: '6px',
        border: '1px solid',
        borderColor: 'neutral.300',
        fontSize: 'sm',
        transition: 'all 0.15s ease',
        _hover: {
          borderColor: 'neutral.400',
        },
        _focus: {
          borderColor: 'brand.400',
          boxShadow: '0 0 0 3px rgba(44, 62, 107, 0.08)',
          bg: 'white',
        },
        _placeholder: {
          color: 'neutral.400',
        },
      },
    },
    admin: {
      field: {
        bg: 'white',
        borderRadius: '6px',
        border: '1px solid',
        borderColor: 'neutral.300',
        fontSize: 'sm',
        transition: 'all 0.15s ease',
        _hover: {
          borderColor: 'neutral.400',
        },
        _focus: {
          borderColor: 'brand.400',
          boxShadow: '0 0 0 3px rgba(44, 62, 107, 0.08)',
        },
        _placeholder: {
          color: 'neutral.400',
        },
      },
    },
  },
};

const Textarea = {
  variants: {
    clean: {
      ...Input.variants.clean.field,
    },
    admin: {
      ...Input.variants.admin.field,
    },
  },
};

const Select = {
  variants: {
    clean: {
      field: {
        ...Input.variants.clean.field,
      },
    },
    admin: {
      field: {
        ...Input.variants.admin.field,
      },
    },
  },
};

export { Input, Textarea, Select };
